import { ArrowUpRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';

export const SeeFullComparisonButton = () => {
  const { t } = useTranslation('subscription_page');

  return (
    <div className="flex justify-center">
      <Button asChild variant="secondary">
        <a
          href="https://www.quickchat.ai/pricing"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="see-full-comparison"
        >
          {t('pricing.see_full_comparison')}
          <ArrowUpRight />
        </a>
      </Button>
    </div>
  );
};
